import * as Actions from 'FormsUI/actions/inventory';
const INITIAL_STATE = {
  ownedProducts: [],
  bundles: []
};
const inventory = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Actions.SUCCEED_FETCH_INVENTORY:
      return {
        ownedProducts: action.payload.ownedProducts,
        bundles: action.payload.bundles
      };
    default:
      return state;
  }
};
export default inventory;